import { RowModel, flexRender } from '@tanstack/react-table';
import { Link } from 'react-router-dom';
import { NavigationConfig } from '../../ui/AppTable/AppTable';
import styles from './TableBody.module.scss';

interface TableBodyProps<TData> {
  rows: RowModel<TData>['rows'];
  navigationConfig?: NavigationConfig<TData>[];
  onRowClick?: (row: TData) => void;
  getRowClassName?: (row: TData) => string | undefined;
}

export const TableBody = <T,>({
  rows,
  navigationConfig,
  onRowClick,
  getRowClassName,
}: TableBodyProps<T>) => {
  const getNavigationConfig = (columnId: string) =>
    navigationConfig?.find((config) => config.columnId === columnId);

  const handleRowClick = (row: T) => {
    if (onRowClick) {
      onRowClick(row);
    }
  };

  return (
    <tbody>
      {rows.map((row) => (
        <tr
          key={row.id}
          className={`${styles.row} ${onRowClick ? styles.clickable : ''} ${getRowClassName?.(row.original) ?? ''}`}
          onClick={() => handleRowClick(row.original)}
        >
          {row.getVisibleCells().map((cell) => {
            const navConfig = getNavigationConfig(cell.column.id);
            const cellContent = flexRender(cell.column.columnDef.cell, cell.getContext());

            return (
              <td key={cell.id} className={styles.cell}>
                {navConfig ? (
                  <Link to={navConfig.getUrl(row.original)} className={styles.navigationLink}>
                    {cellContent}
                  </Link>
                ) : (
                  cellContent
                )}
              </td>
            );
          })}
        </tr>
      ))}
    </tbody>
  );
};
